import React, { useContext, useEffect, useState } from 'react';
import { Heading, Container, useToast, HStack, Box, Button } from '@chakra-ui/react';
import CreateCampaignButton from '../components/campaigns/CreateCampaignButton';
import { HttpContext } from '../context/HttpContext';
import CampaignList from '../components/campaigns/CampaignList';
import Search from '../common/UIcomponents/SearchList';
import { usePaginator } from 'chakra-paginator';
import { AuthContext } from '../context/AuthContext';
import FilterCampaigns from '../components/campaigns/FilterCampaignDropdown';
import SageRestartSync from '../components/vendors/SageRestartSync';
import { INITIAL_PAGE_SIZE } from '../util/consts';
import { DownloadIcon } from '../assets/iconsComponents/downloadIcon';
import { useHistory, useLocation } from 'react-router-dom';

export default function InfluencerPortalCampaigns() {
  const history = useHistory();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const clearedOrderBy = {
    name: null,
    campaignCode: null,
    budget: null,
    currency: null,
    podLeader: null,
    status: null,
    approvalStatus: null,
    startDate: null,
    endDate: null,
    numberOfPos: null,
  };
  const initialOrderBy = {
    name: null,
    campaignCode: null,
    budget: null,
    currency: null,
    podLeader: null,
    status: null,
    approvalStatus: null,
    startDate: null,
    endDate: null,
    numberOfPos: null,
  };
  const [campaignsState, setCampaignsState] = useState({
    campaigns: [],
    loading: true,
    total: 0,
  });

  const [order, setOrder] = useState(initialOrderBy);
  const [term, setTerm] = useState(searchParams.get('search') || '');
  const [filterStatus, setFilterStatus] = useState(searchParams.get('status') || '');
  const [filterApprovalStatus, setFilterApprovalStatus] = useState(
    searchParams.get('approvalStatus') || ''
  );
  const [filterCurrency, setFilterCurrency] = useState(
    searchParams.get('currency') || ''
  );
  const [filterPodLeader, setFilterPodLeader] = useState(
    searchParams.get('podLeader') || ''
  );
  const [filterDateStartFrom, setFilterDateStartFrom] = useState(
    searchParams.get('dateStartFrom') || ''
  );
  const [filterDateStartTo, setFilterDateStartTo] = useState(
    searchParams.get('dateStartTo') || ''
  );
  const [filterDateEndFrom, setFilterDateEndFrom] = useState(
    searchParams.get('dateEndFrom') || ''
  );
  const [filterDateEndTo, setFilterDateEndTo] = useState(
    searchParams.get('dateEndTo') || ''
  );

  const { authAxios } = useContext(HttpContext);
  const auth = useContext(AuthContext);
  const toast = useToast();

  const { pagesQuantity, currentPage, setCurrentPage, pageSize, setPageSize, offset } =
    usePaginator({
      total: campaignsState.total,
      initialState: {
        pageSize: INITIAL_PAGE_SIZE,
        currentPage: 1,
        isDisabled: false,
      },
    });

  function getSortingQuery(order) {
    if (order.name) {
      return `&sort=campaignName&direction=${order.name}`;
    }
    if (order.campaignCode) {
      return `&sort=campaignCode&direction=${order.campaignCode}`;
    }
    if (order.budget) {
      return `&sort=budget&direction=${order.budget}`;
    }
    if (order.currency) {
      return `&sort=currency&direction=${order.currency}`;
    }
    if (order.podLeader) {
      return `&sort=podLeader&direction=${order.podLeader}`;
    }
    if (order.status) {
      return `&sort=status&direction=${order.status}`;
    }
    if (order.approvalStatus) {
      return `&sort=approvalStatus&direction=${order.approvalStatus}`;
    }
    if (order.startDate) {
      return `&sort=startDate&direction=${order.startDate}`;
    }
    if (order.endDate) {
      return `&sort=endDate&direction=${order.endDate}`;
    }
    if (order.numberOfPos) {
      return `&sort=numberOfPos&direction=${order.numberOfPos}`;
    }

    return '';
  }

  useEffect(() => {
    const params = new URLSearchParams();
    if (filterStatus) params.set('status', filterStatus);
    if (filterApprovalStatus) params.set('approvalStatus', filterApprovalStatus);
    if (filterCurrency) params.set('currency', filterCurrency);
    if (filterPodLeader) params.set('podLeader', filterPodLeader);
    if (filterDateStartFrom) params.set('dateStartFrom', filterDateStartFrom);
    if (filterDateStartTo) params.set('dateStartTo', filterDateStartTo);
    if (filterDateEndFrom) params.set('dateEndFrom', filterDateEndFrom);
    if (filterDateEndTo) params.set('dateEndTo', filterDateEndTo);
    if (term) params.set('search', term);
    history.replace({ pathname: location.pathname, search: params.toString() });
  }, [
    history,
    location.pathname,
    filterStatus,
    filterApprovalStatus,
    filterCurrency,
    filterPodLeader,
    filterDateStartFrom,
    filterDateStartTo,
    filterDateEndFrom,
    filterDateEndTo,
    term,
  ]);

  useEffect(() => {
    const getPortalData = async () => {
      try {
        const sort = getSortingQuery(order);
        let url = `campaigns?limit=${pageSize}&offset=${offset}${sort}`;
        if (term.trim()) url += `&search=${encodeURIComponent(term)}`;
        if (filterStatus) url += `&status=${filterStatus}`;
        if (filterApprovalStatus) url += `&approvalStatus=${filterApprovalStatus}`;
        if (filterCurrency) url += `&currency=${filterCurrency}`;
        if (filterPodLeader) url += `&podLeader=${filterPodLeader}`;
        if (filterDateStartFrom && filterDateStartTo) {
          url += `&dateStartFrom=${filterDateStartFrom}&dateStartTo=${filterDateStartTo}`;
        }
        if (filterDateEndFrom && filterDateEndTo) {
          url += `&dateEndFrom=${filterDateEndFrom}&dateEndTo=${filterDateEndTo}`;
        }
        const { data } = await authAxios.get(url);
        const campaigns = (data && data.data) || [];
        const total = (data && data.meta && data.meta.total) || 0;
        setCampaignsState({
          campaigns,
          total,
          loading: false,
        });
      } catch (onError) {
        console.log(onError);
        setCampaignsState({
          ...campaignsState,
          loading: false,
        });
      }
    };

    getPortalData();
  }, [
    authAxios,
    currentPage,
    pageSize,
    offset,
    order,
    term,
    filterStatus,
    filterApprovalStatus,
    filterCurrency,
    filterPodLeader,
    filterDateStartFrom,
    filterDateStartTo,
    filterDateEndFrom,
    filterDateEndTo,
  ]);

  function addCampaign(campaign) {
    const old = campaignsState.campaigns;
    setCurrentPage(1);
    setCampaignsState({
      ...campaignsState,
      campaigns: [campaign, ...old],
    });
    toast({
      position: 'top',
      description:
        'You have successfully created the campaign. You will be notified when the finance team activates it.',
      status: 'success',
      duration: 6000,
      isClosable: true,
    });
  }

  function updateSupplier(supplier) {
    const newSuppliers = campaignsState.campaigns;
    let recordIndex = newSuppliers.findIndex((x) => x.id === supplier.id);
    newSuppliers[recordIndex] = { ...supplier };

    setCampaignsState({
      ...campaignsState,
      campaigns: newSuppliers,
    });

    toast({
      position: 'top',
      description: 'You have successfully updated a campaign.',
      status: 'success',
      duration: 6000,
      isClosable: true,
    });
  }

  function updateOrderBy(key, value) {
    setOrder({ ...clearedOrderBy, [key]: value });
    setCurrentPage(1);
  }

  function updateFilterStatus(status) {
    setFilterStatus(status);
    setCurrentPage(1);
  }

  function updateFilterApprovalStatus(status) {
    setFilterApprovalStatus(status);
    setCurrentPage(1);
  }

  function updateFilterCurrency(currency) {
    setFilterCurrency(currency);
    setCurrentPage(1);
  }

  function updateFilterPodLeader(podLeader) {
    setFilterPodLeader(podLeader);
    setCurrentPage(1);
  }

  function updateFilterStartDate(from, to) {
    setFilterDateStartFrom(from);
    setFilterDateStartTo(to);
    setCurrentPage(1);
  }

  function updateFilterEndDate(from, to) {
    setFilterDateEndFrom(from);
    setFilterDateEndTo(to);
    setCurrentPage(1);
  }

  function clearAllFilters() {
    setFilterStatus('');
    setFilterApprovalStatus('');
    setFilterCurrency('');
    setFilterPodLeader('');
    setFilterDateStartFrom('');
    setFilterDateStartTo('');
    setFilterDateEndFrom('');
    setFilterDateEndTo('');
    setCurrentPage(1);
  }

  const handlePageChange = (nextPage) => {
    setCurrentPage(nextPage);
  };

  const handlePageSizeChange = (event) => {
    const pageSize = Number(event.target.value);
    setPageSize(pageSize);
    setCurrentPage(1);
  };

  function updateTerm(term) {
    setCurrentPage(1);
    setTerm(term);
  }

  const handleCsvDownload = async () => {
    try {
      const sort = getSortingQuery(order);
      let csvUrl = `campaigns?limit=${pageSize}&offset=${offset}${sort}`;
      if (term.trim()) csvUrl += `&search=${encodeURIComponent(term)}`;
      if (filterStatus) csvUrl += `&status=${filterStatus}`;
      if (filterApprovalStatus) csvUrl += `&approvalStatus=${filterApprovalStatus}`;
      if (filterCurrency) csvUrl += `&currency=${filterCurrency}`;
      if (filterPodLeader) csvUrl += `&podLeader=${filterPodLeader}`;
      if (filterDateStartFrom && filterDateStartTo) {
        csvUrl += `&dateStartFrom=${filterDateStartFrom}&dateStartTo=${filterDateStartTo}`;
      }
      if (filterDateEndFrom && filterDateEndTo) {
        csvUrl += `&dateEndFrom=${filterDateEndFrom}&dateEndTo=${filterDateEndTo}`;
      }
      csvUrl += `&export=true`;
      const response = await authAxios.get(csvUrl, {
        responseType: 'blob',
      });
      const blob = new Blob([response.data], { type: 'text/csv; charset=UTF-8' });
      const url = window.URL.createObjectURL(blob);
      let a = document.createElement('a');
      document.body.appendChild(a);
      a.href = url;
      a.download = 'campaigns.csv';
      a.click();
    } catch (onError) {
      console.log(onError);
    }
  };

  return (
    <Container w="100%" maxWidth="100%" pt={4} pr={10} pl={10} pb={14}>
      {auth.isFinance() && auth.getAccessToken() && <SageRestartSync />}
      <Heading as="h2" size="lg" textAlign="left" fontWeight="700" pt={4} mb={[4, 4, 5]}>
        Campaigns
      </Heading>
      <HStack justifyContent="space-between">
        <Box>
          {auth.isPodLeader() && <CreateCampaignButton addCampaign={addCampaign} />}
        </Box>
        <Box display="flex" flexDirection="row">
          {auth.isFinance() && (
            <Button
              leftIcon={<DownloadIcon width="17px" color="#fff" height="19px" />}
              colorScheme="brand"
              borderRadius="8px"
              fontSize="14px"
              fontWeight="500"
              pt="18px"
              pb="18px"
              _hover={campaignsState?.campaigns?.length === 0 ? null : { bg: '#000' }}
              _expanded={{ bg: 'black', color: 'white' }}
              _focus={{ boxShadow: 'none' }}
              onClick={handleCsvDownload}
              disabled={campaignsState?.campaigns?.length === 0}
              mr="1rem"
            >
              Download (.csv)
            </Button>
          )}
          <Search updateTerm={updateTerm} initialValue={term} />
          <Box width="15px" />
          <FilterCampaigns
            clearAllFilters={clearAllFilters}
            updateFilterStatus={updateFilterStatus}
            updateFilterApprovalStatus={updateFilterApprovalStatus}
            updateFilterCurrency={updateFilterCurrency}
            updateFilterStartDate={updateFilterStartDate}
            updateFilterEndDate={updateFilterEndDate}
            updateFilterPodLeader={updateFilterPodLeader}
          />
        </Box>
      </HStack>
      <CampaignList
        campaigns={campaignsState.campaigns}
        handlePageSizeChange={handlePageSizeChange}
        handlePageChange={handlePageChange}
        currentPage={currentPage}
        pagesQuantity={pagesQuantity}
        updateSupplier={updateSupplier}
        isCampaign={auth.isCampaignManager()}
        isFinance={auth.isFinanceManager()}
        orderBy={order}
        updateOrderBy={updateOrderBy}
        loading={campaignsState.loading}
      />
    </Container>
  );
}
